<template>
  <div>
    <div class="wrap coaching-view-wrap">
      <div class="top-header">
        <!-- <incBack @click="handleBack()"></incBack> -->
        <button @click="handleBack()"><img src="@/assets/img/back-icon.svg" alt="preview" /></button>
        <h3>코칭일지</h3>
      </div>

      <!-- 미작성 코칭일지 -->
      <div class="body-wrap" style="display: none">
        <div class="time">
          <img src="@/assets/img/time-icon-b.svg" alt="시간 아이콘" />
          <p>2021.06.21(월) 15:00~16:00 (60분)</p>
        </div>
        <div class="coach">
          <div class="w-100per clear">
            <div class="w-50per float-left txt-left">
              <p class="company">두산중공업</p>
            </div>
            <div class="w-50per float-left txt-right">
              <a href="#" class="survey">서베이 보기</a>
            </div>
          </div>
          <div class="info">
            <h3>박성해 <span>코치</span></h3>
            <h4>화상코칭 <span></span>2회기</h4>
          </div>
          <div class="contact">
            <ul>
              <li>
                <img src="@/assets/img/mic.svg" />
                <img src="@/assets/img/talk-message.svg" alt="대화아이콘" class="ml-20" />
              </li>
            </ul>
          </div>
        </div>
        <div class="coach-goal">
          <ul>
            <li>
              <h3>관심 코칭 주제</h3>
              <p class="preline">1. 리더십-목표설정</p>
            </li>
            <li>
              <h3>코칭 목표</h3>
              <p class="preline">
                · 불확실한 비즈니스 환경에서 조직의 변화와 혁신을 통해 성장을 가능하게 할 것입니다. · 조직의 문제점, 성장 출발점을
                찾을 수 있는 통찰력&코칭경영전략을 학습합니다. · 구성원 간 갈등해소방법, 수평적 코칭커뮤니케이션 스킬 등을
                익히겠습니다.
              </p>
            </li>
            <li>
              <h3>기타의견</h3>
              <p class="preline">
                · 조직 구성원들의 자긍심 향상. 조직 내 정체성, 소속감 확립 · 조직원들간의 인정, 사려 깊은 태도 형성
              </p>
            </li>
          </ul>
        </div>
        <div class="w-90per mg-auto clear">
          <div class="modify-btn w-100per float-left">
            <a href="">수정하기</a>
          </div>
        </div>
      </div>

      <!-- 작성 완료 코칭 일지 -->
      <div class="body-wrap">
        <incCourse :sessionIdx="sessionIdx"></incCourse>
        <div class="coach-goal" style="border-bottom: 0">
          <ul>
            <li>
              <h3>대면 장소</h3>
              <p class="preline">{{ coarching_note.coarchingnoteArea }}</p>
            </li>
            <li>
              <h3>본 세션 코칭 주제</h3>
              <p class="preline">{{ coarching_note.coarchingnoteSession }}</p>
            </li>
            <li>
              <h3>목표 달성 날짜</h3>
              <p class="preline">{{ coarching_note.coarchingnoteFinishdate }}</p>
            </li>
            <li>
              <h3>코칭 내용</h3>
              <p class="preline">{{ coarching_note.coarchingnoteContent1 }}</p>
            </li>
            <li>
              <h3>과제 및 차후 계획</h3>
              <p class="preline">{{ coarching_note.coarchingnoteContent2 }}</p>
            </li>
            <li>
              <h3>코치’s Comment</h3>
              <p class="preline">{{ coarching_note.coarchingnoteComment }}</p>
            </li>
            <li>
              <h3>메모</h3>
              <p class="preline">{{ coarching_note.coarchingnoteMemo }}</p>
            </li>
          </ul>
        </div>
        <div class="w-90per mg-auto clear">
          <div class="modify-btn w-100per float-left">
            <a @click="modify()">수정하기</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import incBack from "@/components/inc/inc_back.vue";
import incCourse from "@/components/inc/inc_course.vue";
export default {
  name: "coaching_journal_view",
  props: {
    sessionIdx: {
      type: [Number, String],
      default: 0,
    },
  },
  data: () => ({
    coarching_note: {},
  }),
  components: {
    incBack,
    incCourse,
  },
  mounted() {
    this.getNoteDetail();
  },
  methods: {
    getNoteDetail() {
      let params = {
        sessionIdx: this.sessionIdx,
      };
      this.axios
        .get("/front/coarching/complete/note/detail", { params })
        .then((res) => {
          if (res.data.success) {
            this.coarching_note = res.data.contentinfo.coarchingNoteDetail;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    modify() {
      this.$router.push({
        name: "coaching_journal_edit",
        params: { sessionIdx: this.sessionIdx, courseIdx: this.coarching_note.courseIdx },
      });
    },
    handleBack() {
      history.go(-2);
    },
  },
};
</script>
